export default __webpack_public_path__ + "f916b7f60342fb307d837d112835d732.png";